var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 16,
    viewBox: "0 0 33 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 1H1V15H32V1Z",
    fill: "#BCEF3F",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82 11V3.85H8.41L11.42 9.02V3.85H12.63V11H11.25L8.03 5.52V11H6.82ZM16.4419 11.1C14.9019 11.1 13.7919 10.09 13.7919 8.44V8.36C13.7919 6.74 14.9019 5.66 16.3919 5.66C17.6919 5.66 18.8619 6.43 18.8619 8.3V8.65H15.0319C15.0719 9.64 15.5719 10.2 16.4719 10.2C17.2019 10.2 17.5819 9.91 17.6719 9.4H18.8419C18.6719 10.5 17.7819 11.1 16.4419 11.1ZM15.0519 7.84H17.6619C17.6019 6.94 17.1419 6.54 16.3919 6.54C15.6619 6.54 15.1719 7.03 15.0519 7.84ZM20.9348 11L19.3348 5.77H20.6248L21.6648 9.55L22.7748 5.77H23.7848L24.8048 9.55L25.8948 5.77H27.0748L25.4348 11H24.2048L23.2348 7.48L22.1748 11H20.9348Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBadge);
export default __webpack_public_path__ + "static/media/new_badge.8878db9686858422646bdbf42651641e.svg";
export { ForwardRef as ReactComponent };